

































































































































































































































































import DateMixin from "@/mixins/DateMixin";
import AccountIdValdationMixin from "@/mixins/AccountIdValdationMixin";
import { Component, Mixins } from "vue-property-decorator";
import MonthPicker from "@/components/ui/MonthPicker.vue";
import FormValidator from "@/mixins/FormValidator";
import RedStar from "@/components/ui/RedStar.vue";
import moment from "moment";
import { DalModule } from "@/store/dal.module";
import { BaseModule } from "@/store/base.module";
import GlobalMixin from "@/mixins/GlobalMixin";
import { translate } from "@/utils";

@Component({
  components: { MonthPicker, RedStar },
})
export default class RegistrationView extends Mixins(
  DateMixin,
  AccountIdValdationMixin,
  FormValidator,
  GlobalMixin,
) {
  formRef = "forReg";
  account_id: number = null as any;
  summ: string = null as any;
  email: string = null as any;
  period = {
    from: "",
    to: "",
    min: "",
    max: "",
  };
  showPassword: boolean = false;
  password: string = null as any;
  passwordRepeated: string = null as any;
  firstname: string = null as any;
  lastname: string = null as any;
  middlename: string = null as any;
  loading: boolean = false;

  async save() {
    try {
      this.loading = true;
      if (!this.validateForm()) return;
      const res = await DalModule.registration({
        account_id: this.account_id,
        summ: Number.parseFloat(this.summ),
        email: this.email,
        password: this.password,
        firstname: this.firstname.trim(),
        lastname: this.lastname.trim(),
        middlename: this.middlename ? this.middlename.trim() : (null as any),
        Year: moment(this.period.to).year(),
        Month: moment(this.period.to).month() + 1,
        recaptchaToken: await this.recaptcha("/registration"),
      });
      if (res && res.result == true) {
        BaseModule.showMessage({
          message: "registr.RegistrationSuccess",
        });
        this.$router.push({ name: "auth" });
      } else {
        let message = "";
        if (res?.reason == "email-exist") {
          message = this.$t("change-email.exists").toString();
        } else if (res?.reason == "invalid-data") {
          message = this.$t("account-info.add-invalid-data").toString();
        } else if (res?.reason == "too-many-attempts") {
          message = this.$t("account-info.add-too-many-attempts", {
            minutes: res.retryAfterMinutes,
          }).toString();
        } else if (res?.data?.message?.name___Ru) {
          // ошибка с сервера, например, не пройдена reCaptcha
          message = translate<any>(res.data.message).name;
        } else {
          message = this.$t("registr.RegistrationError").toString();
        }
        BaseModule.showMessage({
          message: message,
          color: "error",
        });
      }
    } finally {
      this.loading = false;
    }
  }

  async recaptcha(action: string) {
    await this.$recaptchaLoaded();
    return await this.$recaptcha(action);
  }

  passwordConfirmationRule() {
    return (
      this.password === this.passwordRepeated ||
      this.$t("form-validator.pass_rep_incorr")
    );
  }

  async mounted() {
    const today = new Date();
    this.period.to = moment(today).format("YYYY-MM");
    this.period.min = moment(today)
      .add(-11, "M")
      .format("YYYY-MM");
    this.period.max = moment(today).format("YYYY-MM");

    // this.account_id = 6508146;
    // this.summ = 12330.01;
    // this.email = "skmk2@list.ru";
    // this.password = "!Q@W3e4r";
    // this.passwordRepeated = "!Q@W3e4r";
    // this.firstname = "  Иванов  ";
    // this.lastname = "  Иван  ";
    // this.middlename = "Иванович";
  }
}
